import catalogData from '../../../data/catalog.json';
import type { CategoryKey } from '../../public/types/store';

export type AdministrationRoute = 'Oral' | 'Topico' | 'Oticos/Oftalmicos' | 'Inyectables';

export type Medicine = {
  id: number;
  categoryKey: CategoryKey;
  name: string;
  brand: string;
  manufacturer: string;
  description: string;
  concentration: string | null;
  pharmaceuticalForm: string;
  presentation: string;
  sanitaryRegistrationNumber: string;
  activeIngredient: string;
  route: AdministrationRoute;
  quantity: number;
  unitPrice: number;
  featured?: boolean;
  image?: string;
  tags?: string[];
};

export const ROUTE_OPTIONS: AdministrationRoute[] = [
  'Oral',
  'Topico',
  'Oticos/Oftalmicos',
  'Inyectables',
];

export function buildInitialMedicines(): Medicine[] {
  return catalogData.products as Medicine[];
}
